<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/20-FCP-articulate-your-new-skills-to-employers.svg"
                class="img-fluid"
                alt="Assess your employability skills"
                srcset=""
              >
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
        <div class="p-4">
          <p>Your on-campus work experience is also valuable when preparing for future interviews. Think about what you’ve learned and how you can use this to write a <a href="https://www.youtube.com/watch?v=hGkIVxwxrCk" target="_blank">compelling elevator pitch</a>.</p>
          <p>When speaking to potential employers, address the value of both the technical and transferable skills you’ve developed during this time. Don’t assume interviewers will see the connection between your on-campus work experience and the job you’re applying for. Make sure to describe how the knowledge you gained will allow you to perform on the job and meet their expectations.</p>
          <p>Keep in mind that employers don’t just want to hear about your work experience—they want to know the <strong>skills you developed</strong> as a result of the experience.</p>
        </div>
    </content-block>

    <content-block class="p-4">
      <h2 class="content-block__header">Putting this into practice with STAR</h2>
      <p>Practice using the <a href="https://ca.indeed.com/career-advice/interviewing/star-interview-method" target="_blank">STAR method</a> to prepare for your next interview.</p>
      <div class="carousel carousel--orange">
        <hooper
          ref="carousel_01"
          class="mb-4"
        >
          <slide>
            <div class="slide">
              <div>
                <h3><strong>Situation</strong></h3>
                <p>Describe a scenario that took place during your on-campus job.</p>
              </div>
            </div>
          </slide>

          <slide>
            <div class="slide row">
              <div>
                <h3><strong>Task</strong></h3>
                <p>Talk about your responsibilities.</p>
              </div>
            </div>
          </slide>

          <slide>
            <div class="slide row">
              <div>
                <h3><strong>Action</strong></h3>
                <p>Explain the steps you took in that particular situation.</p>
              </div>
            </div>
          </slide>

          <slide>
            <div class="slide row">
              <div>
                <h3><strong>Result</strong></h3>
                <p>Conclude with a positive outcome and describe what results you achieved.</p>
              </div>
            </div>
          </slide>

          <hooper-navigation slot="hooper-addons">
            <img
              slot="hooper-prev"
              src="@/assets/img/_ui/svg/carousel-back--orange.svg"
              alt="previous"
              srcset=""
            >
            <img
              slot="hooper-next"
              src="@/assets/img/_ui/svg/carousel-next--orange.svg"
              alt="next"
              srcset=""
            >
          </hooper-navigation>

          <hooper-pagination slot="hooper-addons"></hooper-pagination>
        </hooper>
      </div>
    </content-block>
    <content-block>
      <div class="learn-more learn-more--orange m-4">
        <p><strong>Learn more</strong>
        <ul>
          <li><a href="https://www.youtube.com/watch?v=mH3DaeJSwy4&amp;t=163s" target="_blank">How to answer behavioural interview questions</a> video</li>
        </ul></p>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    // Accordion
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
